export const GET_PARTICIPANTS_LIST = 'GET_PARTICIPANTS_LIST ';
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT';
export const REMOVE_PARTICIPANT = 'REMOVE_PARTICIPANT';
export const HAND_RAISED = 'HAND_RAISED';
export const HAND_UNRAISED = 'HAND_UNRAISED';
export const CHANGE_SUBSCRIBER_ROLE = 'CHANGE_SUBSCRIBER_ROLE';
